import React, { useEffect, useMemo, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import uRLs from "../../baseUtils";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import Convertinvoice from "../../../components/pages/sale/ConvertInvoice";
import InvoiceActionFooter from "../a4Invoices/common/InvoiceActionFooter";
import InvoiceInfoSidebar from "../a4Invoices/common/InvoiceInfoSidebar";
import InvoiceToggleActionCard from "../a4Invoices/common/InvoiceToggleActionCard";
import InvoicePreviewRenderer from "./common/InvoiceHA4PreviewRender";
import PaySettleModal from "./common/PaySettleModal ";
import InvoiceModalLayout from "./common/InvoiceModalLayout ";
import { useContextApi } from "../../../context/ContextApi";
import {
  capitalizeFirstLetter,
  loadImageDimensions,
} from "./common/invoiceUtils";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import Messages from "../../../constants/Messages";
import AxiosInstance from "../../AxiosInstance";
import handleError from "../../../constants/handleError";
import InterRegular from "../../../components/pages/estimation/font/Inter_24pt-Regular-normal";
import InterBold from "../../../components/pages/estimation/font/Inter_24pt-Bold-normal";
import NotoSansMonoBold from "../../../components/pages/sale/font/NotoSansMono-Bold-bold";
import NotoSansMonoReular from "../../../components/pages/sale/font/NotoSansMono-Regular-normal";
import CommercialInvoice from "../a4Invoices/CommercialInvoice";
import EssentialInvoice from "../a4Invoices/EssentialInvoice";
import LegendExecutiveInvoice from "../a4Invoices/LegendExecutiveInvoice";
import PrimeInvoice from "../a4Invoices/PrimeInvoice";
import ServiceInvoice from "../a4Invoices/ServiceInvoice";
import StructuredInvoice from "../a4Invoices/StructuredInvoice";
import ProfessionalGSTInvoice from "../a4Invoices/ProfessionalGSTInvoice";

const ReturnSaleInvoice = ({
  isData,
  saleId,
  selectedOption,
  onClose,
  onDataUpdate,
  onDataChange,
  isActive,
  optData,
  setOptData,
}) => {
  const [data, setData] = useState({});
  const { storeSettings } = usePermission();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);
  const selectedTheme = storeSettings?.invoiceSettings?.template;
  const [selectedSize, setSelectedSize] = useState(
    storeSettings?.printerSettings?.paperSize,
  );  
  const SaleReturnData = data?.returnSaleData || isData?.returnSaleData;
  const formattedDataForInvoice = {
    ...data,
    returnSaleData: SaleReturnData,
    // Normalize paymentInfo into an array so .map() never crashes!
    paymentInfo: Array.isArray(data?.paymentInfo)
      ? data.paymentInfo
      : Array.isArray(data?.paymentInfo?.refundPaymentMethods)
        ? data.paymentInfo.refundPaymentMethods
        : Array.isArray(isData?.paymentInfo)
          ? isData.paymentInfo
          : [],
  };
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { useEscapeKey } = useContextApi();
  const latestVersion = useMemo(() => {
    return isData?.saleVersion;
  }, [isData]);
  const [download, setDownload] = useState(false);

  const [billing, setBilling] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectHALFA4Option, setSelectHALFA4Option] = useState("HA4RES");
  const [closeAuto, setCloseAuto] = useState(true);
  const [saleLoading, setSaleLoading] = useState(false);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
   const preSaleMode = data?.preSaleData?.preSaleMode?.toUpperCase();
 const isPreSale = ["PROFORMA_INVOICE", "ESTIMATION", "QUOTATION"].includes(preSaleMode);
  
  useEffect(() => {
    setData(isData);
  }, [isData]);
  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal",
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS(
          "NotoSansMono_24pt-Regular-normal.ttf",
          NotoSansMonoReular,
        );
        this.addFileToVFS(
          "NotoSansMono_24pt-Bold-normal.ttf",
          NotoSansMonoBold,
        );
        this.addFont(
          "NotoSansMono_24pt-Regular-normal.ttf",
          "NotoSansMono-Regular",
          "normal",
        );
        this.addFont(
          "NotoSansMono_24pt-Bold-normal.ttf",
          "NotoSansMono-Bold",
          "bold",
        );
      },
    ]);
  }, []);

  const [showConfirm, setShowConfirm] = useState(false);
  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      setModalOpen(true);
      setSelectedSale(response?.data?.results);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };
  const handleResetSale = () => {
    setSaleLoading(true);
    setTimeout(() => {
      if (saleId) {
        handleSaleItems(saleId);
      } else {
        setData(selectedSale?.saleData);
      }
      setSaleLoading(false);
    }, 300);
    setCloseAuto(false);
  };
  const handlelatestSale = (sale) => {
    setSelectedSale(sale);
  };
  const ReturnSaleTitle = "CREDIT NOTE";

  const handleGenerateInvoice = async (data) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const payload = {
        saleid: data._id,
        toSaleMode: "INVOICE",
      };
      var response = await AxiosInstance.patch(
        "module/sale/convert-salemode",
        payload,
      );
      setData(response.data.results);
      if (onDataChange) {
        onDataUpdate();
      }
      showAlert("success", Messages.SUCCESS.SALE_ADDED);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
      setShowConfirm(false);
    }
  };
  const handleModeConfirm = () => {
    setShowConfirm(true);
  };
  //

  const { isUser } = useAuth();
  const handleClose = () => {
    setIsMainModalOpen(false);
    onClose();
  };

  const saleDate = SaleReturnData?.saleReturnDate;
  const timezone = "Asia/Kolkata";
  let saleTime = "--:--";
  let createdTime = {
    date: "--",
    time: "--",
  };

  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }
  if (SaleReturnData?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(
      SaleReturnData?.createdAt,
      timezone,
    );
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }
  const invLabel = "Credit No:";
  const invFrom = "Credit From:";
  const invTo = "Customer:";

  const paymentRows = [];
  const generateinvoicePDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 7;
    const headerX = 2;
    const headerY = 2;
    const imagePath =
      uRLs?.IMAGE_URL +
      "profile/" +
      SaleReturnData?.billingStoreProfileData?.image;

    if (SaleReturnData?.billingStoreProfileData?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 20;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = SaleReturnData?.salemode && ReturnSaleTitle;
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (SaleReturnData?.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }
    // Prepare font size for labels and values
    doc.setFontSize(10);
    const invoiceNoLabel = invLabel;
    const invoiceNoValue = SaleReturnData?.saleReturnNo;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = saleTime.date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 10;
    const innerGap = 2;
    const invoiceRowY = 25;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    const sectionTop = 30;
    const col2X = padding;
    doc.setFontSize(8);
    const hasSaleToData =
      SaleReturnData?.CustomerInfo &&
      (SaleReturnData?.CustomerInfo?.name ||
        SaleReturnData?.CustomerInfo?.addressline1 ||
        SaleReturnData?.CustomerInfo?.addressline2 ||
        SaleReturnData?.CustomerInfo?.district ||
        SaleReturnData?.CustomerInfo?.country ||
        SaleReturnData?.CustomerInfo?.pincode ||
        SaleReturnData?.CustomerInfo?.phone ||
        SaleReturnData?.CustomerInfo?.email ||
        SaleReturnData?.CustomerInfo?.gstnumber ||
        SaleReturnData?.CustomerInfo?.state ||
        SaleReturnData?.CustomerInfo?.statecode ||
        SaleReturnData?.CustomerInfo?.referenceid);

    const summaryWidth = 70;
    const summaryX = pageWidth - padding - summaryWidth;
    let summaryY = sectionTop;

    // FIX 1: Dynamic calculation to give customer details max available width before hitting the box
    const sectionWidth = summaryX - col2X - 8;

    // FIX 2: Adjusted Customer title to align perfectly with the "Summary" internal text row
    if (hasSaleToData && optData?.isCustomerDisplay) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(invTo, col2X, sectionTop + 4);
    }

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    // FIX 3: Set initial starting coordinates for details to match box layout flow
    let fromY = sectionTop + 10;
    let toY = sectionTop + 10;

    const sectionGap = 12;

    let toDetails = [];
    if (hasSaleToData) {
      toDetails = [
        { bold: true, text: SaleReturnData?.CustomerInfo?.name || "-" },
        {
          bold: false,
          text: [
            SaleReturnData?.CustomerInfo?.addressline1,
            SaleReturnData?.CustomerInfo?.addressline2,
            SaleReturnData?.CustomerInfo?.district,
            SaleReturnData?.CustomerInfo?.country,
            SaleReturnData?.CustomerInfo?.pincode
              ? `${SaleReturnData?.CustomerInfo.pincode}` // Removed the trailing dangling hyphen styling
              : "",
          ]
            .filter(Boolean)
            .join(", "),

          ...(SaleReturnData?.CustomerInfo?.phone
            ? [
                {
                  bold: false,
                  text: `Phone: ${SaleReturnData?.CustomerInfo?.phone}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.email
            ? [
                {
                  bold: false,
                  text: `Email: ${SaleReturnData?.CustomerInfo?.email}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.referenceid
            ? [
                {
                  bold: false,
                  text: "Reference No:",
                  suffix: ` ${SaleReturnData?.CustomerInfo?.referenceid}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.gstnumber
            ? [
                {
                  bold: true,
                  text: `GST:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.gstnumber}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.fssai
            ? [
                {
                  bold: true,
                  text: `FSSAI:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.fssai || ""}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.cinnumber
            ? [
                {
                  bold: true,
                  text: `CIN:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.cinnumber || ""}`,
                },
              ]
            : []),

          ...(SaleReturnData?.CustomerInfo?.pannumber
            ? [
                {
                  bold: true,
                  text: `PAN:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.pannumber || ""}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.state
            ? [
                {
                  bold: true,
                  text: `State:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.state} [ State Code: ${
                    SaleReturnData?.CustomerInfo?.statecode || ""
                  } ]`,
                },
              ]
            : []),
        },
      ];
    }
    const wrapText = (text, maxWidth) => doc.splitTextToSize(text, maxWidth);
    const lineHeight = 4.5; // Slightly increased for matching summary grid line heights

    const renderDetails = (details, startX, startY) => {
      let y = startY;
      details.forEach(({ bold, text, suffix = "" }) => {
        const fullText = text + suffix;
        const lines = wrapText(fullText, sectionWidth);
        lines.forEach((line, index) => {
          if (index === 0 && suffix && bold) {
            const labelWidth = doc.getTextWidth(text);
            doc.setFont("Inter-Bold", "bold");
            doc.text(text, startX, y);
            doc.setFont("Inter-Regular", "normal");
            doc.text(suffix, startX + labelWidth, y);
          } else {
            doc.setFont(
              bold ? "Inter-Bold" : "Inter-Regular",
              bold ? "bold" : "normal",
            );
            doc.text(line, startX, y);
          }
          y += lineHeight;
        });
      });

      return y;
    };

    let shippingY = sectionTop + 5;
    if (hasSaleToData && optData?.isCustomerDisplay) {
      toY = renderDetails(toDetails, col2X, toY);
    }

    const summaryHeight = 25;
    doc.setLineWidth(0.1);
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    const themeColor = selectedTheme?.templateTheme?.primaryColor || "#F0F5FF";
    doc.setFillColor(themeColor);
    doc.roundedRect(
      summaryX,
      summaryY,
      summaryWidth,
      summaryHeight,
      2,
      2,
      "FD",
    );

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.setTextColor(50, 50, 50);
    doc.text(" Original Invoice Summary", summaryX + 4, summaryY + 5);

    doc.setLineWidth(0.15);
    doc.line(
      summaryX + 4,
      summaryY + 7.5,
      summaryX + summaryWidth - 4,
      summaryY + 7.5,
    );

    const summaryRows = [
      { label: "Sale Mode", value: SaleReturnData?.salemode || "INVOICE" },
      { label: "Sale No", value: SaleReturnData?.saleNo || "-" },
      {
        label: "Sale Date",
        value:
          DateConverter.ISOToDisplayFormat(
            DateConverter.convertToTimeZone(
              SaleReturnData?.originalSaleDate,
              isUser?.timezone,
            ),
          ).date || "-",
      },
    ];

    let rowY = summaryY + 12.5;
    const rowLineHeight = 4.5;

    summaryRows.forEach((row) => {
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text(row.label, summaryX + 4, rowY);

      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(0, 0, 0);

      const valWidth = doc.getTextWidth(row.value);
      doc.text(row.value, summaryX + summaryWidth - 4 - valWidth, rowY);

      rowY += rowLineHeight;
    });

    shippingY = summaryY + summaryHeight + 6;
    const maxSectionY = Math.max(fromY, toY, shippingY);

    // 3. Product Table
    const productBody = SaleReturnData?.returnItems?.map((item, i) => {
      const qty = item?.quantity || 1;
      const landingCost = item?.lineTotalLandingCost;
      const rate = CurrencyConverter.toCurrency(item?.returnPrice || 0, "INR");
      // const gross = item?.lineTotalSoldPrice;
      const taxable = CurrencyConverter.toCurrency(
        item?.lineTotalBasePrice || 0,
        "INR",
      );
      const gstPercentage = item?.taxPercentage;
      const gstAmt = CurrencyConverter.toCurrency(
        item?.lineTotalTaxAmount || 0,
        "INR",
      );
      const total = CurrencyConverter.toCurrency(
        item?.lineGrandTotal || 0,
        "INR",
      );
      const desc = [
        `${item.title}`,
        ...(item?.itemRemarks ? [`"Remark" : ${item.itemRemarks}`] : []),
        ...(item?.itemCondition ? [`"Condition" : ${item.itemCondition}`] : []),
        ...(item?.imode === "PRODUCT" && item?.note ? [item?.note] : []),
        ...(item?.imode === "SERVICE" && item?.description
          ? [item?.description]
          : []),
        ...(item?.hsnsac
          ? [`${item?.hsnsac === "SERVICE" ? "SAC" : "HSN"} : ${item.hsnsac}`]
          : []),
      ].join("\n");
      return [
        i + 1,
        desc,
        `₹${rate}`,
        `${qty} ${(() => {
          const unitCode = item?.isSecondaryUnit
            ? item?.unitConfig?.secondaryUnitCode
            : item?.unitConfig?.primaryUnitCode;

          // return unitCode !== "unit" ? unitCode : "";
          return unitCode || "";
        })()}`,
        // `₹${gross}`,
        `₹${taxable}`,
        `${gstPercentage}%`,
        `₹${gstAmt}`,
        `₹${total}`,
      ];
    });

    const soldTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.totalsoldprice || 0,
      "INR",
    );

    const baseTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.totalbaseprice || 0,
      "INR",
    );

    const taxTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.totaltaxamount || 0,
      "INR",
    );

    const grandTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.returnGrandTotalRounded || 0,
      "INR",
    );

    // // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "",
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${baseTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: ``,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${taxTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${grandTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);
    autoTable(doc, {
      startY: maxSectionY,
      head: [
        [
          "S.No",
          "Description",
          " Rate",
          "Qty",
          // "Gross Amount",
          "Tax Val",
          "GST(%)",
          "GST Amount",
          "Total Return",
        ],
      ],
      body: productBody,
      margin: { left: 6, right: 5 }, // add right margin if needed
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 9,
        halign: "middle",
        cellPadding: 2,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: "#041121",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
        fontStyle: "bold",
        font: "Inter-Bold",
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 13, halign: "center", valign: "middle" },
        1: {
          cellWidth: "auto",
          halign: "left",
          styles: {
            overflow: "linebreak",
          },
        },
        2: { cellWidth: 25, halign: "right" },
        3: { cellWidth: 13, halign: "center" },
        4: { cellWidth: 25, halign: "right" },
        5: { cellWidth: 18, halign: "right" },
        6: { cellWidth: 19, halign: "right" },
        7: { cellWidth: 25, halign: "right" },
      },

      theme: "grid",
    });

    const totalBase = CurrencyConverter.toCurrency(
      SaleReturnData?.totalbaseprice || 0,
      "INR",
    );

    const igst = CurrencyConverter.toCurrency(
      SaleReturnData?.returnIgstamount || 0,
      "INR",
    );

    const sgst = CurrencyConverter.toCurrency(
      SaleReturnData?.returnSgstamount || 0,
      "INR",
    );

    const cgst = CurrencyConverter.toCurrency(
      SaleReturnData?.returnCgstamount || 0,
      "INR",
    );

    const totalSold = CurrencyConverter.toCurrency(
      SaleReturnData?.totalReturnAmount || 0,
      "INR",
    );

    const isInterState =
      SaleReturnData?.billingStoreProfileData?.statecode &&
      SaleReturnData?.CustomerInfo?.statecode &&
      SaleReturnData?.billingStoreProfileData.statecode !==
        SaleReturnData?.CustomerInfo.statecode;
    const body = [
      [
        {
          content: "Total Amount In Words",
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 9,
            valign: "top",
          },
        },
        {
          content: "Total Amount Before Tax",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${totalBase}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ],
      [
        {
          content: SaleReturnData?.amountinwordsTotalReturnAmount,
          rowSpan: isInterState ? 3 : 4,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 9,
          },
        },
        {
          content: isInterState ? "IGST" : "SGST",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: isInterState ? `₹${igst}` : `₹${sgst}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ],
    ];
    if (!isInterState) {
      body.push([
        { content: "CGST", styles: { halign: "right", fontSize: 9 } },
        {
          content: `₹${cgst}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ]);
    }
    // Add Total row
    body.push([
      { content: "Total", styles: { halign: "right", fontSize: 9 } },
      {
        content: `₹${totalSold}`,
        styles: { halign: "right", valign: "middle", fontSize: 9 },
      },
    ]);
    // Add Grand Total row
    body.push([
      {
        content: "Grand Total (Rounded)",
        styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
      },
      {
        content: `₹${grandTotal}`,
        styles: {
          halign: "right",
          valign: "middle",
          fontStyle: "bold",
          fontSize: 10,
        },
      },
    ]);
    const afterProductsY = doc.lastAutoTable?.finalY + 0.3;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 50;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: { left: 6, right: 5 },
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 2,
        fontSize: 9,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
      },
      columnStyles: {
        0: { cellWidth: 113 },
        1: { cellWidth: 62, halign: "right" },
        2: { cellWidth: 25, halign: "center", valign: "middle" },
      },
      didParseCell: function (data) {
        if (data.row.index === 0 && isSamePage) {
          data.cell.styles.lineWidth = {
            top: 0,
            right: 0.2,
            bottom: 0.2,
            left: 0.2,
          };
        }
        const lastRowIndex = body.length - 1;
        if (data.section === "body") {
          if (
            data.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.fillColor = "#f4f4f6";
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    let currentY = finalY + 8;
    const TotalDiscount = SaleReturnData.totaldiscount;
    if (parseFloat(SaleReturnData?.totaldiscount) > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(
        `Your Total Discount : ₹${CurrencyConverter.toCurrency(SaleReturnData?.totaldiscount || 0, "INR")}`,
        105,
        currentY,
        {
          align: "center",
        },
      );

      currentY += 9; // ONLY if discount exists
    }

    // // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------

    const payacsh = CurrencyConverter.toCurrency(payDetails?.CASH || 0, "INR");
    const payacard = CurrencyConverter.toCurrency(payDetails?.CARD || 0, "INR");
    const payaonline = CurrencyConverter.toCurrency(
      payDetails?.ONLINE || 0,
      "INR",
    );
    const payUpi = CurrencyConverter.toCurrency(payDetails?.UPI || 0, "INR");
    const payPaylater = CurrencyConverter.toCurrency(
      payDetails?.PAYLATER || 0,
      "INR",
    );
    // // condition based rows
    if (payDetails?.CASH > 0) {
      paymentRows.push(["Cash", `₹${payacsh}`]);
    }

    if (payDetails?.CARD > 0) {
      paymentRows.push(["Card", `₹${payacard}`]);
    }

    if (payDetails?.ONLINE > 0) {
      paymentRows.push(["Online Amount", `₹${payaonline}`]);
    }

    if (payDetails?.UPI > 0) {
      paymentRows.push(["UPI", `₹${payUpi}`]);
    }

    if (payDetails?.BALANCE > 0) {
      paymentRows.push(["Balance Due", `₹${payPaylater}`]);
    }

    // // draw table ONLY if rows exist
    if (paymentRows.length > 0) {
      autoTable(doc, {
        startY: currentY,
        head: [["Refund Method", ""]],
        body: paymentRows,
        margin: { left: 6 },
        tableWidth: 70,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 2,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 40, halign: "left" },
          1: { cellWidth: 30, halign: "right" },
        },
        theme: "grid",
      });

      currentY = doc.lastAutoTable.finalY + 6;
    }
    const innerPaddingX = 2;
    // ===================== Remark =====================
    if (optData?.isRemark && SaleReturnData?.remarks) {
      // Page break check
      if (currentY > pageHeight - 35) {
        doc.addPage();
        currentY = padding + 5;
      }

      const remarkX = padding;
      const innerPaddingX = 2;
      const remarkWidth = pageWidth - padding * 2 - innerPaddingX * 2 + 5;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(72, 72, 72);
      doc.text("Remark", remarkX, currentY);

      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(SaleReturnData.remarks),
        remarkWidth + 30,
      );

      const lineHeight = 4;
      const paddingTop = 2.5;
      const paddingBottom = 2.5;

      const remarkHeight =
        paddingTop + remarkLines.length * lineHeight + paddingBottom;

      const boxY = currentY + 4;

      // Border
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
      doc.setLineWidth(0.2);
      // Remark Text
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.setTextColor(0);

      let textY = boxY + paddingTop - 1;

      remarkLines.forEach((line) => {
        doc.text(line, remarkX, textY);
        textY += lineHeight;
      });

      // Move below remark
      currentY = boxY + remarkHeight + 4;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
      align: "center",
    });
    if (storeSettings?.negobillBranding) {
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    currentY += 8;

    const rightX = pageWidth - padding;

    const boxTopY = currentY + 3;

    const SIGN_Y = boxTopY; // Signature image
    const LABEL_Y = SIGN_Y + 8; // "Issued By, Signature"
    const STORE_Y = LABEL_Y + 4; // Store name

    // // Fonts
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    // // -------- 1️⃣ Signature Image FIRST ----------
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 50;
        const maxHeight = 10;

        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgWidth = width * ratio;
        const imgHeight = height * ratio;

        const format = signimg.endsWith(".png") ? "PNG" : "JPEG";
        const imgX = rightX - imgWidth;

        doc.addImage(base64, format, imgX, SIGN_Y, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    // // -------- 2️⃣ Issued By, Signature ----------
    doc.text("Issued By, Signature", rightX, LABEL_Y + 4, { align: "right" });

    // // -------- 3️⃣ Store Name ----------
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(7);

    const titleText = String(
      SaleReturnData?.billingStoreProfileData?.title || "",
    );
    doc.text(titleText, rightX, STORE_Y + 4, { align: "right" });

    setDownload(false);
    // setPrint(false);
    return doc;
  };

  const generateIN_HA4_HA4RES = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const HALF_PAGE_HEIGHT = 140;
    const padding = 5;
    const headerX = 2;
    const headerY = 2;
    const imagePath =
      uRLs?.IMAGE_URL +
      "profile/" +
      SaleReturnData?.billingStoreProfileData?.image;

    if (SaleReturnData?.billingStoreProfileData?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 20;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = SaleReturnData?.salemode && ReturnSaleTitle;
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (SaleReturnData?.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }
    // Prepare font size for labels and values
    doc.setFontSize(10);
    const invoiceNoLabel = invLabel;
    const invoiceNoValue = SaleReturnData?.saleReturnNo;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = saleTime.date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 10;
    const innerGap = 2;
    const invoiceRowY = 25;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    const sectionTop = 30;
    const col2X = padding;
    doc.setFontSize(8);
    const hasSaleToData =
      SaleReturnData?.CustomerInfo &&
      (SaleReturnData?.CustomerInfo?.name ||
        SaleReturnData?.CustomerInfo?.addressline1 ||
        SaleReturnData?.CustomerInfo?.addressline2 ||
        SaleReturnData?.CustomerInfo?.district ||
        SaleReturnData?.CustomerInfo?.country ||
        SaleReturnData?.CustomerInfo?.pincode ||
        SaleReturnData?.CustomerInfo?.phone ||
        SaleReturnData?.CustomerInfo?.email ||
        SaleReturnData?.CustomerInfo?.gstnumber ||
        SaleReturnData?.CustomerInfo?.state ||
        SaleReturnData?.CustomerInfo?.statecode ||
        SaleReturnData?.CustomerInfo?.referenceid);

    const summaryWidth = 70;
    const summaryX = pageWidth - padding - summaryWidth;
    let summaryY = sectionTop;

    // FIX 1: Dynamic calculation to give customer details max available width before hitting the box
    const sectionWidth = summaryX - col2X - 8;

    // FIX 2: Adjusted Customer title to align perfectly with the "Summary" internal text row
    if (hasSaleToData && optData?.isCustomerDisplay) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(invTo, col2X, sectionTop + 4);
    }

    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    // FIX 3: Set initial starting coordinates for details to match box layout flow
    let fromY = sectionTop + 10;
    let toY = sectionTop + 10;

    const sectionGap = 12;

    let toDetails = [];
    if (hasSaleToData) {
      toDetails = [
        { bold: true, text: SaleReturnData?.CustomerInfo?.name || "-" },
        {
          bold: false,
          text: [
            SaleReturnData?.CustomerInfo?.addressline1,
            SaleReturnData?.CustomerInfo?.addressline2,
            SaleReturnData?.CustomerInfo?.district,
            SaleReturnData?.CustomerInfo?.country,
            SaleReturnData?.CustomerInfo?.pincode
              ? `${SaleReturnData?.CustomerInfo.pincode}` // Removed the trailing dangling hyphen styling
              : "",
          ]
            .filter(Boolean)
            .join(", "),

          ...(SaleReturnData?.CustomerInfo?.phone
            ? [
                {
                  bold: false,
                  text: `Phone: ${SaleReturnData?.CustomerInfo?.phone}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.email
            ? [
                {
                  bold: false,
                  text: `Email: ${SaleReturnData?.CustomerInfo?.email}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.referenceid
            ? [
                {
                  bold: false,
                  text: "Reference No:",
                  suffix: ` ${SaleReturnData?.CustomerInfo?.referenceid}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.gstnumber
            ? [
                {
                  bold: true,
                  text: `GST:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.gstnumber}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.fssai
            ? [
                {
                  bold: true,
                  text: `FSSAI:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.fssai || ""}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.cinnumber
            ? [
                {
                  bold: true,
                  text: `CIN:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.cinnumber || ""}`,
                },
              ]
            : []),

          ...(SaleReturnData?.CustomerInfo?.pannumber
            ? [
                {
                  bold: true,
                  text: `PAN:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.pannumber || ""}`,
                },
              ]
            : []),
          ...(SaleReturnData?.CustomerInfo?.state
            ? [
                {
                  bold: true,
                  text: `State:`,
                  suffix: ` ${SaleReturnData?.CustomerInfo?.state} [ State Code: ${
                    SaleReturnData?.CustomerInfo?.statecode || ""
                  } ]`,
                },
              ]
            : []),
        },
      ];
    }
    const wrapText = (text, maxWidth) => doc.splitTextToSize(text, maxWidth);
    const lineHeight = 4.5; // Slightly increased for matching summary grid line heights

    const renderDetails = (details, startX, startY) => {
      let y = startY;
      details.forEach(({ bold, text, suffix = "" }) => {
        const fullText = text + suffix;
        const lines = wrapText(fullText, sectionWidth);
        lines.forEach((line, index) => {
          if (index === 0 && suffix && bold) {
            const labelWidth = doc.getTextWidth(text);
            doc.setFont("Inter-Bold", "bold");
            doc.text(text, startX, y);
            doc.setFont("Inter-Regular", "normal");
            doc.text(suffix, startX + labelWidth, y);
          } else {
            doc.setFont(
              bold ? "Inter-Bold" : "Inter-Regular",
              bold ? "bold" : "normal",
            );
            doc.text(line, startX, y);
          }
          y += lineHeight;
        });
      });

      return y;
    };

    let shippingY = sectionTop + 5;
    if (hasSaleToData && optData?.isCustomerDisplay) {
      toY = renderDetails(toDetails, col2X, toY);
    }

    const summaryHeight = 25;
    doc.setLineWidth(0.1);
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    const themeColor = selectedTheme?.templateTheme?.primaryColor || "#F0F5FF";
    doc.setFillColor(themeColor);
    doc.roundedRect(
      summaryX,
      summaryY,
      summaryWidth,
      summaryHeight,
      2,
      2,
      "FD",
    );

    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.setTextColor(50, 50, 50);
    doc.text(" Original Invoice Summary", summaryX + 4, summaryY + 5);

    doc.setLineWidth(0.15);
    doc.line(
      summaryX + 4,
      summaryY + 7.5,
      summaryX + summaryWidth - 4,
      summaryY + 7.5,
    );

    const summaryRows = [
      { label: "Sale Mode", value: SaleReturnData?.salemode || "INVOICE" },
      { label: "Sale No", value: SaleReturnData?.saleNo || "-" },
      {
        label: "Sale Date",
        value:
          DateConverter.ISOToDisplayFormat(
            DateConverter.convertToTimeZone(
              SaleReturnData?.originalSaleDate,
              isUser?.timezone,
            ),
          ).date || "-",
      },
    ];

    let rowY = summaryY + 12.5;
    const rowLineHeight = 4.5;

    summaryRows.forEach((row) => {
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text(row.label, summaryX + 4, rowY);

      doc.setFont("Inter-Bold", "bold");
      doc.setTextColor(0, 0, 0);

      const valWidth = doc.getTextWidth(row.value);
      doc.text(row.value, summaryX + summaryWidth - 4 - valWidth, rowY);

      rowY += rowLineHeight;
    });

    shippingY = summaryY + summaryHeight + 6;
    const maxSectionY = Math.max(fromY, toY, shippingY);

    // 3. Product Table
    const productBody = SaleReturnData?.returnItems?.map((item, i) => {
      const qty = item?.quantity || 1;
      const landingCost = item?.lineTotalLandingCost;
      const rate = CurrencyConverter.toCurrency(item?.returnPrice || 0, "INR");
      // const gross = item?.lineTotalSoldPrice;
      const taxable = CurrencyConverter.toCurrency(
        item?.lineTotalBasePrice || 0,
        "INR",
      );
      const gstPercentage = item?.taxPercentage;
      const gstAmt = CurrencyConverter.toCurrency(
        item?.lineTotalTaxAmount || 0,
        "INR",
      );
      const total = CurrencyConverter.toCurrency(
        item?.lineGrandTotal || 0,
        "INR",
      );
      const desc = [
        `${item.title}`,
        ...(item?.itemRemarks ? [`"Remark" : ${item.itemRemarks}`] : []),
        ...(item?.itemCondition ? [`"Condition" : ${item.itemCondition}`] : []),
        ...(item?.imode === "PRODUCT" && item?.note ? [item?.note] : []),
        ...(item?.imode === "SERVICE" && item?.description
          ? [item?.description]
          : []),
        ...(item?.hsnsac
          ? [`${item?.hsnsac === "SERVICE" ? "SAC" : "HSN"} : ${item.hsnsac}`]
          : []),
      ].join("\n");
      return [
        i + 1,
        desc,
        `₹${rate}`,
        `${qty} ${(() => {
          const unitCode = item?.isSecondaryUnit
            ? item?.unitConfig?.secondaryUnitCode
            : item?.unitConfig?.primaryUnitCode;

          // return unitCode !== "unit" ? unitCode : "";
          return unitCode || "";
        })()}`,
        // `₹${gross}`,
        `₹${taxable}`,
        `${gstPercentage}%`,
        `₹${gstAmt}`,
        `₹${total}`,
      ];
    });

    const soldTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.totalsoldprice || 0,
      "INR",
    );

    const baseTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.totalbaseprice || 0,
      "INR",
    );

    const taxTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.totaltaxamount || 0,
      "INR",
    );

    const grandTotal = CurrencyConverter.toCurrency(
      SaleReturnData?.returnGrandTotalRounded || 0,
      "INR",
    );

    // // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "",
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${baseTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: ``,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${taxTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${grandTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);
    autoTable(doc, {
      startY: maxSectionY,
      head: [
        [
          "S.No",
          "Description",
          " Rate",
          "Qty",
          // "Gross Amount",
          "Tax Val",
          "GST(%)",
          "GST Amount",
          "Total Return",
        ],
      ],
      body: productBody,
      margin: {
        top: padding,
        left: padding,
        right: padding,
        bottom: pageH - HALF_PAGE_HEIGHT + padding,
      }, // add right margin if needed
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 9,
        halign: "middle",
        cellPadding: 2,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: "#041121",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
        fontStyle: "bold",
        font: "Inter-Bold",
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 13, halign: "center", valign: "middle" },
        1: {
          cellWidth: "auto",
          halign: "left",
          styles: {
            overflow: "linebreak",
          },
        },
        2: { cellWidth: 25, halign: "right" },
        3: { cellWidth: 13, halign: "center" },
        4: { cellWidth: 25, halign: "right" },
        5: { cellWidth: 18, halign: "right" },
        6: { cellWidth: 19, halign: "right" },
        7: { cellWidth: 25, halign: "right" },
      },

      theme: "grid",
    });
    const body = [
      [
        {
          content: `Total Amount In Words : ${SaleReturnData?.amountinwordsTotalReturnAmount}`,
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 9,
            valign: "top",
          },
        },
        {
          content: "Grand Total (Rounded)",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${grandTotal}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ],
    ];

    const afterProductsY = doc.lastAutoTable?.finalY + 0.3;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 50;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: {
        top: padding,
        left: padding,
        right: padding,
        bottom: pageH - HALF_PAGE_HEIGHT + padding,
      },
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 2,
        fontSize: 9,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
      },
      columnStyles: {
        0: { cellWidth: 113 },
        1: { cellWidth: 62, halign: "right" },
        2: { cellWidth: 25, halign: "center", valign: "middle" },
      },
      didParseCell: function (data) {
        if (data.row.index === 0 && isSamePage) {
          data.cell.styles.lineWidth = {
            top: 0,
            right: 0.2,
            bottom: 0.2,
            left: 0.2,
          };
        }
        const lastRowIndex = body.length - 1;
        if (data.section === "body") {
          if (
            data.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.fillColor = "#f4f4f6";
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    let currentY = finalY + 2;
    // ===================== Remark =====================
    if (optData?.isRemark && SaleReturnData?.remarks) {
      // Page break check
      if (currentY > pageHeight - 35) {
        doc.addPage();
        currentY = padding + 5;
      }

      const remarkX = padding;
      const innerPaddingX = 2;
      const remarkWidth = pageWidth - padding * 2 - innerPaddingX * 2 + 5;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(72, 72, 72);
      doc.text("Remark", remarkX, currentY);

      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(SaleReturnData.remarks),
        remarkWidth + 30,
      );

      const lineHeight = 4;
      const paddingTop = 2.5;
      const paddingBottom = 2.5;

      const remarkHeight =
        paddingTop + remarkLines.length * lineHeight + paddingBottom;

      const boxY = currentY + 4;

      // Border
      doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
      doc.setLineWidth(0.2);
      // Remark Text
      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      doc.setTextColor(0);

      let textY = boxY + paddingTop - 1;

      remarkLines.forEach((line) => {
        doc.text(line, remarkX, textY);
        textY += lineHeight;
      });

      // Move below remark
      currentY = boxY + remarkHeight + 4;
    }

    const rightX = pageWidth - padding;

    const boxTopY = currentY + 3;

    const SIGN_Y = boxTopY; // Signature image
    let LABEL_Y = SIGN_Y + 8; // "Issued By, Signature"

    // // Fonts
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    // // -------- 1️⃣ Signature Image FIRST ----------
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 50;
        const maxHeight = 10;

        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgWidth = width * ratio;
        const imgHeight = height * ratio;

        const format = signimg.endsWith(".png") ? "PNG" : "JPEG";
        const imgX = rightX - imgWidth;

        doc.addImage(base64, format, imgX, SIGN_Y, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }
    LABEL_Y += 4;
    doc.text("Issued By, Signature", rightX, LABEL_Y, { align: "right" });
    currentY += 2;
    if (storeSettings?.negobillBranding) {
      currentY = LABEL_Y + 5;

      const normalText = "Powered by ";
      const boldText = "NegoBill.com";

      doc.setFont("Inter-Regular", "normal");
      const normalW = doc.getTextWidth(normalText);

      doc.setFont("Inter-Bold", "bold");
      const boldW = doc.getTextWidth(boldText);

      const totalWidth = normalW + boldW;

      // Center horizontally
      const startX = (pageWidth - totalWidth) / 2;

      doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX, currentY);

      doc.setFont("Inter-Bold", "bold");
      doc.text(boldText, startX + normalW, currentY);
    }
    doc.setFontSize(7);
    setDownload(false);
    // setPrint(false);
    return doc;
  };
  const handlePrintTemplate = async () => {
    if (selectedSize === "HALFA4") {
      return await generateIN_HA4_HA4RES();
    }
    return await generateinvoicePDF();
  };
  const payDetails = Array.isArray(data?.paymentInfo?.refundPaymentMethods)
    ? data.paymentInfo.refundPaymentMethods
    : Array.isArray(isData?.paymentInfo?.refundPaymentMethods)
      ? isData.paymentInfo.refundPaymentMethods
      : [];

  const handleSelectedReturnSale = async (sale) => {
    setSaleLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/salereturn/${sale?._id}`,
      );
      setTimeout(() => {
        setData(response.data.results);
        setSaleLoading(false);
      }, 300);

      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  if (isModalOpen) {
    const invoiceComponentMap = {
      INVPRO: ProfessionalGSTInvoice,
      INVOICEONE: ProfessionalGSTInvoice,

      INVESS: EssentialInvoice,
      INVOICETWO: EssentialInvoice,

      INVSTR: StructuredInvoice,
      INVOICEFOUR: StructuredInvoice,

      INVCOM: CommercialInvoice,
      INVOICEFIVE: CommercialInvoice,

      INVSEV: ServiceInvoice,
      INVOICESIX: ServiceInvoice,

      INVLEX: LegendExecutiveInvoice,

      INVPRM: PrimeInvoice,
    };
    const InvoiceComponent = invoiceComponentMap[selectedOption];

    if (!InvoiceComponent) {
      return null;
    }
    return (
      <InvoiceComponent
        isData={selectedSale}
        isActive={isActive}
        selectedOption={selectedOption}
        onClose={handleClose}
        optData={optData}
        setOptData={setOptData}
        onDataUpdate={async () => {
          const updatedData = await handleSaleItems(selectedSale?._id);

          if (updatedData) {
            setSelectedSale(updatedData);
          }
        }}
        onDataChange={true}
      />
    );
  }
  return (
    <>
      <InvoiceModalLayout
        isOpen={isMainModalOpen}
        data={formattedDataForInvoice}
        generateInvoice1={handlePrintTemplate}
        generateBill1={handlePrintTemplate}
        handlePrintTemplate={handlePrintTemplate}
        displayCreatedTime={createdTime}
        latestVersion={latestVersion}
        isBtnLoading={isBtnLoading}
        handleResetSale={handleResetSale}
        handleModeConfirm={handleModeConfirm}
        onClose={handleClose}       
        isPreSale={isPreSale}     
        isActive={isActive}
        isMainModalOpen={isMainModalOpen}
        billing={billing}
        selectHALFA4Option={selectHALFA4Option}
        selectTermalOption={selectTermalOption}
        selectedSize={selectedSize}  
        setSelectedSize={setSelectedSize}
        selectedOption={selectedOption}
        optData={optData}
        setBilling={setBilling}
        setDownload={setDownload}       
        download={download}
      >
        <InvoiceToggleActionCard
          optData={optData}
          returnTrack={SaleReturnData?.returnTrack}
          setOptData={setOptData}
          setBilling={setBilling}
          setSelectTermalOption={setSelectTermalOption}
          setSelectHALFA4Option={setSelectHALFA4Option}
        />
        {saleLoading ? (
          <div
            className="d-flex justify-content-center"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            <CircularProgress size={20} className="text-primary" />
          </div>
        ) : (
          <div
            className="pt-2"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            {selectedSize === "HALFA4" ? (
              <>
                <>
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                <td width="50%" style={{ textAlign: "left" }}>
                                  <div className="tm_logo">
                                    {SaleReturnData?.billingStoreProfileData
                                      ?.image && (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          "profile/" +
                                          SaleReturnData
                                            ?.billingStoreProfileData?.image
                                        }
                                        className="img-rounded logo mb-0"
                                        height="30"
                                      />
                                    )}
                                  </div>
                                </td>
                                <td width="50%" style={{ textAlign: "right" }}>
                                  <div className="tm_primary_color font-20 fw-bold tm_text_uppercase">
                                    {SaleReturnData?.salemode && (
                                      <>{ReturnSaleTitle}</>
                                    )}
                                  </div>
                                  {SaleReturnData?.status === "CANCELLED" && (
                                    <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                      {SaleReturnData?.status}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="tm_invoice_info tm_mb20">
                            <div
                              className="tm_invoice_seperator tm_gray_bg"
                              style={{
                                backgroundColor:
                                  selectedTheme?.templateTheme?.primaryColor,
                              }}
                            ></div>
                            <div className="tm_invoice_info_list">
                              <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                                <b className="tm_primary_color">{invLabel} </b>{" "}
                                {SaleReturnData?.saleReturnNo}
                              </p>
                              <p className="tm_invoice_date tm_m0 mt-3">
                                <b className="tm_primary_color"> Date: </b>{" "}
                                {saleTime.date}
                              </p>
                            </div>
                          </div>
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                <div className="row">
                                  {/* <td width="5%"></td> */}
                                  {optData?.isCustomerDisplay && (
                                    <div
                                      className="col-md-7 col-12"
                                      style={{ verticalAlign: "top" }}
                                    >
                                      {SaleReturnData?.CustomerInfo &&
                                        (SaleReturnData?.CustomerInfo?.name ||
                                          SaleReturnData?.CustomerInfo
                                            ?.addressline1 ||
                                          SaleReturnData.CustomerInfo
                                            ?.addressline2 ||
                                          SaleReturnData?.CustomerInfo?.state ||
                                          SaleReturnData?.CustomerInfo
                                            ?.district ||
                                          SaleReturnData?.CustomerInfo
                                            ?.country ||
                                          SaleReturnData?.CustomerInfo
                                            ?.pincode ||
                                          SaleReturnData?.CustomerInfo?.phone ||
                                          SaleReturnData?.CustomerInfo?.email ||
                                          SaleReturnData?.CustomerInfo
                                            ?.gstnumber ||
                                          SaleReturnData?.CustomerInfo
                                            ?.statecode ||
                                          SaleReturnData?.CustomerInfo
                                            ?.referenceid) && (
                                          <div>
                                            <div
                                              style={{
                                                fontSize: "14px",
                                                lineHeight: "22px",
                                                fontWeight: "600",
                                                marginBottom: "0px",
                                              }}
                                            >
                                              {invTo}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                marginBottom: "0px",
                                              }}
                                            >
                                              {SaleReturnData?.CustomerInfo
                                                ?.name || ""}
                                            </div>
                                            <div
                                              style={{
                                                fontSize: "12px",
                                                lineHeight: "18px",
                                                marginBottom: "0px",
                                              }}
                                            >
                                              <div>
                                                {SaleReturnData?.CustomerInfo
                                                  ?.addressline1 || ""}{" "}
                                                {SaleReturnData?.CustomerInfo
                                                  ?.addressline2 || ""}{" "}
                                                {SaleReturnData?.CustomerInfo
                                                  ?.state || ""}{" "}
                                                {SaleReturnData?.CustomerInfo
                                                  ?.district || ""}{" "}
                                                {SaleReturnData?.CustomerInfo
                                                  ?.country || ""}{" "}
                                                {SaleReturnData?.CustomerInfo
                                                  ?.country
                                                  ? " - "
                                                  : ""}{" "}
                                                {SaleReturnData?.CustomerInfo
                                                  ?.pincode || ""}
                                              </div>
                                              {SaleReturnData?.CustomerInfo
                                                ?.phone && (
                                                <div>
                                                  Phone: +91{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.phone
                                                  }
                                                </div>
                                              )}
                                              {SaleReturnData?.CustomerInfo
                                                ?.email && (
                                                <div>
                                                  Email:{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.email
                                                  }
                                                </div>
                                              )}
                                              {SaleReturnData?.CustomerInfo
                                                ?.referenceid && (
                                                <div>
                                                  Reference No:{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.referenceid
                                                  }
                                                </div>
                                              )}
                                              {SaleReturnData?.CustomerInfo
                                                ?.gstnumber && (
                                                <div>
                                                  <strong>GST:</strong>{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.gstnumber
                                                  }
                                                </div>
                                              )}
                                              {SaleReturnData?.CustomerInfo
                                                ?.fssai && (
                                                <div>
                                                  <strong>FASSI:</strong>{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.fssai
                                                  }
                                                </div>
                                              )}
                                              {SaleReturnData?.CustomerInfo
                                                ?.cinnumber && (
                                                <div>
                                                  <strong>CIN:</strong>{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.cinnumber
                                                  }
                                                </div>
                                              )}
                                              {SaleReturnData?.CustomerInfo
                                                ?.pannumber && (
                                                <div>
                                                  <strong>PAN:</strong>{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.pannumber
                                                  }
                                                </div>
                                              )}
                                              {SaleReturnData?.CustomerInfo
                                                ?.state && (
                                                <div>
                                                  <strong>State:</strong>{" "}
                                                  {
                                                    SaleReturnData?.CustomerInfo
                                                      ?.state
                                                  }{" "}
                                                  [ State Code :
                                                  {SaleReturnData?.CustomerInfo
                                                    ?.statecode || ""}{" "}
                                                  ]
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  )}
                                  <div className="col-md-4 col-12 ms-auto">
                                    <div
                                      style={{
                                        border: "1px solid #d6d6d6",
                                        borderRadius: "6px",
                                        background:
                                          selectedTheme?.templateTheme
                                            ?.primaryColor,
                                        padding: "6px 12px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: 600,
                                          fontSize: "12px",
                                          marginBottom: "4px",
                                          borderBottom: "1px solid #ddd",
                                          paddingBottom: "3px",
                                          color: "#b14444",
                                        }}
                                      >
                                        Original Invoice Summary
                                      </div>

                                      <table
                                        style={{
                                          width: "100%",
                                          borderCollapse: "collapse",
                                        }}
                                      >
                                        <tbody>
                                          <tr>
                                            <td
                                              style={{
                                                textAlign: "left",
                                                padding: "2px 0",
                                                color: "#646464",
                                              }}
                                            >
                                              {" "}
                                              {/* Reduced padding from 4px to 2px */}
                                              Sale Mode
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "right",
                                                padding: "2px 0",
                                                color: "#000",
                                              }}
                                            >
                                              <strong>
                                                {SaleReturnData?.salemode ||
                                                  "-"}
                                              </strong>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td
                                              style={{
                                                textAlign: "left",
                                                padding: "2px 0",
                                                color: "#646464",
                                              }}
                                            >
                                              Sale No
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "right",
                                                padding: "2px 0",
                                                color: "#000",
                                              }}
                                            >
                                              <strong>
                                                {SaleReturnData?.saleNo || "-"}
                                              </strong>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td
                                              style={{
                                                textAlign: "left",
                                                padding: "2px 0",
                                                color: "#646464",
                                              }}
                                            >
                                              Sale Date
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "right",
                                                padding: "2px 0",
                                                color: "#000",
                                              }}
                                            >
                                              <strong>
                                                {DateConverter.ISOToDisplayFormat(
                                                  DateConverter.convertToTimeZone(
                                                    SaleReturnData?.originalSaleDate,
                                                    isUser?.timezone,
                                                  ),
                                                ).date || "-"}
                                              </strong>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </tr>
                            </tbody>
                          </table>
                          <table
                            // className="items"
                            width="100%"
                            style={{
                              marginTop: "6px",
                              borderCollapse: "collapse",
                            }}
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "20px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "240px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Description
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "120px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "50px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Qty
                                </th>
                                {/* <th
                                            className="force-style"
                                            style={{
                                              width: "100px",
                                              textAlign: "center",
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Gross Amount
                                          </th> */}
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Tax Val
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "30px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  GST(%)
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  GST Amount
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Total Return
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {SaleReturnData?.returnItems?.map(
                                (product, index) => (
                                  <tr key={index}>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "left",
                                        fontSize: "12px",
                                        width: "30%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      <div>{product.title}</div>
                                      {product?.itemRemarks && (
                                        <div
                                          style={{
                                            fontSize: "11px",
                                            color: "#555",
                                            marginTop: "2px",
                                          }}
                                        >
                                          Remark: {product.itemRemarks}
                                        </div>
                                      )}

                                      {product?.itemCondition && (
                                        <div
                                          style={{
                                            fontSize: "11px",
                                            color: "#555",
                                          }}
                                        >
                                          Condition: {product.itemCondition}
                                        </div>
                                      )}
                                      {product.imode === "SERVICE" && (
                                        <div className="ms-0 fsz-10 lh-13 mb-1">
                                          {product.description}
                                        </div>
                                      )}
                                      {product.imode === "PRODUCT" &&
                                        product.note && (
                                          <div className="ms-0 fsz-10 mb-1">
                                            {product?.note}
                                          </div>
                                        )}
                                      {product?.hsnsac && (
                                        <div>
                                          <span className="fw-medium">
                                            {product?.imode === "SERVICE"
                                              ? "SAC:"
                                              : "HSN:"}
                                          </span>{" "}
                                          {product?.hsnsac}
                                        </div>
                                      )}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        product?.returnPrice || 0,
                                        "INR",
                                      )}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {product?.quantity}
                                      <span className="font-11 ms-1">
                                        {(() => {
                                          const unitCode =
                                            product?.isSecondaryUnit
                                              ? product?.unitConfig
                                                  ?.secondaryUnitCode
                                              : product?.unitConfig
                                                  ?.primaryUnitCode;

                                          // return unitCode !== "unit" ? unitCode : "";
                                          return unitCode || "";
                                        })()}
                                      </span>
                                    </td>
                                    {/* <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "center",
                                                  fontSize: "12px",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              >
                                                ₹{product?.lineTotalSoldPrice}
                                              </td> */}
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        product?.lineTotalBasePrice || 0,
                                        "INR",
                                      )}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      {product.taxPercentage}%
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        product?.lineTotalTaxAmount || 0,
                                        "INR",
                                      )}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        product?.lineGrandTotal || 0,
                                        "INR",
                                      )}
                                    </td>
                                  </tr>
                                ),
                              )}
                              <tr>
                                <td
                                  colSpan={2}
                                  className="force-style"
                                  style={{
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                ></td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Total
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  {/* {globalData?.totalqty} */}
                                </td>
                                {/* 
                                          <td
                                            className="force-style"
                                            style={{
                                              textAlign: "center",
                                              fontSize: "12px",
                                              fontWeight: 600,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            ₹{globalData?.totalsoldprice}
                                          </td> */}
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    SaleReturnData?.totalbaseprice || 0,
                                    "INR",
                                  )}
                                </td>
                                <td></td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    SaleReturnData?.totaltaxamount || 0,
                                    "INR",
                                  )}
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    SaleReturnData?.returnGrandTotalRounded ||
                                      0,
                                    "INR",
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="4"
                                >
                                  Total Amount In Words :{" "}
                                  {
                                    SaleReturnData?.amountinwordsTotalReturnAmount
                                  }
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                  }}
                                  colSpan="3"
                                >
                                  Grand Total (Rounded)
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    SaleReturnData?.returnGrandTotalRounded ||
                                      0,
                                    "INR",
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {SaleReturnData?.totaldiscount > 0 && (
                            <table width="100%">
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: 600,
                                      textAlign: "center",
                                      padding: "8px",
                                      color: "black",
                                    }}
                                  >
                                    Your Total Discount : ₹
                                    {CurrencyConverter.toCurrency(
                                      SaleReturnData?.totaldiscount || 0,
                                      "INR",
                                    )}
                                    {/* <br />
                                    <div className="mt-1 fs-20">
                                      ***** Thank You! Visit Us Again *****
                                    </div> */}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )}
                          {(payDetails?.CASH > 0 ||
                            payDetails?.CARD > 0 ||
                            payDetails?.ONLINE > 0 ||
                            payDetails?.UPI > 0 ||
                            payDetails?.PAYLATER > 0) && (
                            <table
                              className="items mt-2"
                              width="38%"
                              cellPadding="4"
                            >
                              <thead>
                                <tr>
                                  <th
                                    colSpan={2}
                                    className="force-style"
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      "--th-bg":
                                        selectedTheme?.templateTheme
                                          ?.primaryColor,
                                      "--th-color":
                                        selectedTheme?.templateTheme
                                          ?.foregroundColor,
                                    }}
                                  >
                                    Refund Method
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {payDetails?.CASH > 0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Cash
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        payDetails?.CASH || 0,
                                        "INR",
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {payDetails?.CARD > 0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Card
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        payDetails?.CARD || 0,
                                        "INR",
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {payDetails?.ONLINE > 0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      OnlineAmount
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        payDetails?.ONLINE || 0,
                                        "INR",
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {payDetails?.UPI > 0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      UPI
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        payDetails?.UPI || 0,
                                        "INR",
                                      )}
                                    </td>
                                  </tr>
                                )}
                                {payDetails?.PAYLATER > 0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      BalanceDue
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹
                                      {CurrencyConverter.toCurrency(
                                        payDetails?.PAYLATER || 0,
                                        "INR",
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )}
                          {optData?.isRemark && SaleReturnData?.remarks && (
                            <table width="100%" className="mb-2 mt-2">
                              <tbody>
                                <tr>
                                  <td width="100%">
                                    <div className="font-12 fw-600 align-left text-black mb-1">
                                      Remark
                                    </div>

                                    <div
                                      className="font-12 p-0"
                                      style={{
                                        whiteSpace: "pre-wrap",
                                        wordBreak: "break-word",
                                        minHeight: "30px",
                                      }}
                                    >
                                      {capitalizeFirstLetter(
                                        SaleReturnData?.remarks,
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )}

                          <table width="100%">
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    padding: "8px",
                                    marginTop: "15px",
                                  }}
                                  className="d-flex align-items-start justify-content-end"
                                >
                                  <div>
                                    {storeSettings?.invoiceSettings
                                      ?.signature && (
                                      <div className="text-end p-0 fw-bold ">
                                        <img
                                          src={
                                            uRLs.IMAGE_URL +
                                            storeSettings?.invoiceSettings
                                              ?.signature
                                          }
                                          width={150}
                                        />
                                      </div>
                                    )}
                                    <div className="text-end p-0">
                                      Issued By,Signature
                                    </div>
                                    {/* <div className="text-end p-0 fw-bold ">
                                  {
                                    SaleReturnData?.billingStoreProfileData
                                      ?.title
                                  }
                                </div> */}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {storeSettings?.negobillBranding && (
                            <>
                              <div className=" fs-20 d-flex justify-content-center mt-1 ">
                                <span className="me-1">Powered By</span>{" "}
                                <strong>www.NegoBill.com</strong>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </>
            ) : (
              <>
                <div className="tm_container">
                  <div className="tm_invoice_wrap">
                    <div className="tm_invoice tm_style1 tm_type1">
                      <div className="tm_invoice_in p-2">
                        <table width="100%" className="pdfcontent">
                          <tbody>
                            <tr>
                              <td width="50%" style={{ textAlign: "left" }}>
                                <div className="tm_logo">
                                  {SaleReturnData?.billingStoreProfileData
                                    ?.image && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        "profile/" +
                                        SaleReturnData?.billingStoreProfileData
                                          ?.image
                                      }
                                      className="img-rounded logo mb-0"
                                      height="30"
                                    />
                                  )}
                                </div>
                              </td>
                              <td width="50%" style={{ textAlign: "right" }}>
                                <div className="tm_primary_color font-20 fw-bold tm_text_uppercase">
                                  {SaleReturnData?.salemode && (
                                    <>{ReturnSaleTitle}</>
                                  )}
                                </div>
                                {SaleReturnData?.status === "CANCELLED" && (
                                  <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                    {SaleReturnData?.status}
                                  </span>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="tm_invoice_info tm_mb20">
                          <div
                            className="tm_invoice_seperator tm_gray_bg"
                            style={{
                              backgroundColor:
                                selectedTheme?.templateTheme?.primaryColor,
                            }}
                          ></div>
                          <div className="tm_invoice_info_list">
                            <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                              <b className="tm_primary_color">{invLabel} </b>{" "}
                              {SaleReturnData?.saleReturnNo}
                            </p>
                            <p className="tm_invoice_date tm_m0 mt-3">
                              <b className="tm_primary_color"> Date: </b>{" "}
                              {saleTime.date}
                            </p>
                          </div>
                        </div>
                        <table width="100%" className="pdfcontent">
                          <tbody>
                            <tr>
                              {/* <td
                                  width="30%"
                                  style={{ verticalAlign: "top" }}
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      lineHeight: "22px",
                                      fontWeight: "600",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {invFrom}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {SaleReturnData?.billingStoreProfileData
                                      ?.title || ""}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "18px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    <div>
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.addressline1 || ""}{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.addressline2 || ""}{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.district || ""}{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.country || ""}{" "}
                                      -{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.pincode || ""}
                                    </div>
                                    <div>
                                      Phone: +91{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.phone || ""}
                                    </div>
                                    <div>
                                      Email:{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.email || ""}
                                    </div>
                                    {SaleReturnData?.billingStoreProfileData
                                      ?.referenceid && (
                                      <div>
                                        Reference No:{" "}
                                        {
                                          SaleReturnData?.billingStoreProfileData
                                            ?.referenceid
                                        }
                                      </div>
                                    )}
                                    <div>
                                      <strong>GST:</strong>{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.gstnumber || ""}
                                    </div>
                                    {SaleReturnData?.billingStoreProfileData
                                      ?.fssai && (
                                      <div>
                                        <strong>FSSAI:</strong>{" "}
                                        {
                                          SaleReturnData?.billingStoreProfileData
                                            ?.fssai
                                        }
                                      </div>
                                    )}
                                    <div>
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.cinnumber && (
                                        <div>
                                          <strong>CIN:</strong>{" "}
                                          {
                                            SaleReturnData
                                              ?.billingStoreProfileData
                                              ?.cinnumber
                                          }
                                        </div>
                                      )}
                                      <strong>PAN:</strong>{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.pannumber || ""}
                                    </div>
                                    <div>
                                      <strong>State:</strong>{" "}
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.state || ""}{" "}
                                      [ State Code :
                                      {SaleReturnData?.billingStoreProfileData
                                        ?.statecode || ""}{" "}
                                      ]
                                    </div>
                                  </div>
                                </td> */}
                              <div className="row">
                                {/* <td width="5%"></td> */}
                                {optData?.isCustomerDisplay && (
                                  <div
                                    className="col-md-7 col-12"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {SaleReturnData?.CustomerInfo &&
                                      (SaleReturnData?.CustomerInfo?.name ||
                                        SaleReturnData?.CustomerInfo
                                          ?.addressline1 ||
                                        SaleReturnData.CustomerInfo
                                          ?.addressline2 ||
                                        SaleReturnData?.CustomerInfo?.state ||
                                        SaleReturnData?.CustomerInfo
                                          ?.district ||
                                        SaleReturnData?.CustomerInfo?.country ||
                                        SaleReturnData?.CustomerInfo?.pincode ||
                                        SaleReturnData?.CustomerInfo?.phone ||
                                        SaleReturnData?.CustomerInfo?.email ||
                                        SaleReturnData?.CustomerInfo
                                          ?.gstnumber ||
                                        SaleReturnData?.CustomerInfo
                                          ?.statecode ||
                                        SaleReturnData?.CustomerInfo
                                          ?.referenceid) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {invTo}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {SaleReturnData?.CustomerInfo
                                              ?.name || ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {SaleReturnData?.CustomerInfo
                                                ?.addressline1 || ""}{" "}
                                              {SaleReturnData?.CustomerInfo
                                                ?.addressline2 || ""}{" "}
                                              {SaleReturnData?.CustomerInfo
                                                ?.state || ""}{" "}
                                              {SaleReturnData?.CustomerInfo
                                                ?.district || ""}{" "}
                                              {SaleReturnData?.CustomerInfo
                                                ?.country || ""}{" "}
                                              {SaleReturnData?.CustomerInfo
                                                ?.country
                                                ? " - "
                                                : ""}{" "}
                                              {SaleReturnData?.CustomerInfo
                                                ?.pincode || ""}
                                            </div>
                                            {SaleReturnData?.CustomerInfo
                                              ?.phone && (
                                              <div>
                                                Phone: +91{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.phone
                                                }
                                              </div>
                                            )}
                                            {SaleReturnData?.CustomerInfo
                                              ?.email && (
                                              <div>
                                                Email:{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.email
                                                }
                                              </div>
                                            )}
                                            {SaleReturnData?.CustomerInfo
                                              ?.referenceid && (
                                              <div>
                                                Reference No:{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.referenceid
                                                }
                                              </div>
                                            )}
                                            {SaleReturnData?.CustomerInfo
                                              ?.gstnumber && (
                                              <div>
                                                <strong>GST:</strong>{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.gstnumber
                                                }
                                              </div>
                                            )}
                                            {SaleReturnData?.CustomerInfo
                                              ?.fssai && (
                                              <div>
                                                <strong>FASSI:</strong>{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.fssai
                                                }
                                              </div>
                                            )}
                                            {SaleReturnData?.CustomerInfo
                                              ?.cinnumber && (
                                              <div>
                                                <strong>CIN:</strong>{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.cinnumber
                                                }
                                              </div>
                                            )}
                                            {SaleReturnData?.CustomerInfo
                                              ?.pannumber && (
                                              <div>
                                                <strong>PAN:</strong>{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.pannumber
                                                }
                                              </div>
                                            )}
                                            {SaleReturnData?.CustomerInfo
                                              ?.state && (
                                              <div>
                                                <strong>State:</strong>{" "}
                                                {
                                                  SaleReturnData?.CustomerInfo
                                                    ?.state
                                                }{" "}
                                                [ State Code :
                                                {SaleReturnData?.CustomerInfo
                                                  ?.statecode || ""}{" "}
                                                ]
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                )}
                                <div className="col-md-4 col-12 ms-auto">
                                  <div
                                    style={{
                                      border: "1px solid #d6d6d6",
                                      borderRadius: "6px",
                                      background:
                                        selectedTheme?.templateTheme
                                          ?.primaryColor,
                                      padding: "6px 12px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontWeight: 600,
                                        fontSize: "12px",
                                        marginBottom: "4px",
                                        borderBottom: "1px solid #ddd",
                                        paddingBottom: "3px",
                                        color: "#b14444",
                                      }}
                                    >
                                      Original Invoice Summary
                                    </div>

                                    <table
                                      style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                      }}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              textAlign: "left",
                                              padding: "2px 0",
                                              color: "#646464",
                                            }}
                                          >
                                            {" "}
                                            {/* Reduced padding from 4px to 2px */}
                                            Sale Mode
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "right",
                                              padding: "2px 0",
                                              color: "#000",
                                            }}
                                          >
                                            <strong>
                                              {SaleReturnData?.salemode || "-"}
                                            </strong>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            style={{
                                              textAlign: "left",
                                              padding: "2px 0",
                                              color: "#646464",
                                            }}
                                          >
                                            Sale No
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "right",
                                              padding: "2px 0",
                                              color: "#000",
                                            }}
                                          >
                                            <strong>
                                              {SaleReturnData?.saleNo || "-"}
                                            </strong>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            style={{
                                              textAlign: "left",
                                              padding: "2px 0",
                                              color: "#646464",
                                            }}
                                          >
                                            Sale Date
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "right",
                                              padding: "2px 0",
                                              color: "#000",
                                            }}
                                          >
                                            <strong>
                                              {DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  SaleReturnData?.originalSaleDate,
                                                  isUser?.timezone,
                                                ),
                                              ).date || "-"}
                                            </strong>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          // className="items"
                          width="100%"
                          style={{
                            marginTop: "6px",
                            borderCollapse: "collapse",
                          }}
                          cellPadding="4"
                        >
                          <thead>
                            <tr>
                              <th
                                className="force-style"
                                style={{
                                  width: "20px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                S.No
                              </th>
                              <th
                                className="force-style"
                                style={{
                                  width: "240px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                Description
                              </th>
                              <th
                                className="force-style"
                                style={{
                                  width: "120px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                Rate
                              </th>
                              <th
                                className="force-style"
                                style={{
                                  width: "50px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                Qty
                              </th>
                              {/* <th
                                            className="force-style"
                                            style={{
                                              width: "100px",
                                              textAlign: "center",
                                              "--th-color":
                                                selectedTheme?.templateTheme
                                                  ?.foregroundColor,
                                              "--th-bg":
                                                selectedTheme?.templateTheme
                                                  ?.primaryColor,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                            }}
                                          >
                                            Gross Amount
                                          </th> */}
                              <th
                                className="force-style"
                                style={{
                                  width: "100px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                Tax Val
                              </th>
                              <th
                                className="force-style"
                                style={{
                                  width: "30px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                GST(%)
                              </th>
                              <th
                                className="force-style"
                                style={{
                                  width: "100px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                GST Amount
                              </th>
                              <th
                                className="force-style"
                                style={{
                                  width: "100px",
                                  textAlign: "center",
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                }}
                              >
                                Total Return
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {SaleReturnData?.returnItems?.map(
                              (product, index) => (
                                <tr key={index}>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "left",
                                      fontSize: "12px",
                                      width: "30%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    <div>{product.title}</div>
                                    {product?.itemRemarks && (
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          color: "#555",
                                          marginTop: "2px",
                                        }}
                                      >
                                        Remark: {product.itemRemarks}
                                      </div>
                                    )}

                                    {product?.itemCondition && (
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          color: "#555",
                                        }}
                                      >
                                        Condition: {product.itemCondition}
                                      </div>
                                    )}
                                    {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )}
                                    {product.imode === "PRODUCT" &&
                                      product.note && (
                                        <div className="ms-0 fsz-10 mb-1">
                                          {product?.note}
                                        </div>
                                      )}
                                    {product?.hsnsac && (
                                      <div>
                                        <span className="fw-medium">
                                          {product?.imode === "SERVICE"
                                            ? "SAC:"
                                            : "HSN:"}
                                        </span>{" "}
                                        {product?.hsnsac}
                                      </div>
                                    )}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      product?.returnPrice || 0,
                                      "INR",
                                    )}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {product?.quantity}
                                    <span className="font-11 ms-1">
                                      {(() => {
                                        const unitCode =
                                          product?.isSecondaryUnit
                                            ? product?.unitConfig
                                                ?.secondaryUnitCode
                                            : product?.unitConfig
                                                ?.primaryUnitCode;

                                        // return unitCode !== "unit" ? unitCode : "";
                                        return unitCode || "";
                                      })()}
                                    </span>
                                  </td>
                                  {/* <td
                                                className="force-style"
                                                style={{
                                                  textAlign: "center",
                                                  fontSize: "12px",
                                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                }}
                                              >
                                                ₹{product?.lineTotalSoldPrice}
                                              </td> */}
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      product?.lineTotalBasePrice || 0,
                                      "INR",
                                    )}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {product.taxPercentage}%
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      product?.lineTotalTaxAmount || 0,
                                      "INR",
                                    )}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      product?.lineGrandTotal || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                              ),
                            )}
                            <tr>
                              <td
                                colSpan={2}
                                className="force-style"
                                style={{
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              ></td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                Total
                              </td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                {/* {globalData?.totalqty} */}
                              </td>
                              {/* 
                                          <td
                                            className="force-style"
                                            style={{
                                              textAlign: "center",
                                              fontSize: "12px",
                                              fontWeight: 600,
                                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                            }}
                                          >
                                            ₹{globalData?.totalsoldprice}
                                          </td> */}
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  SaleReturnData?.totalbaseprice || 0,
                                  "INR",
                                )}
                              </td>
                              <td></td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  SaleReturnData?.totaltaxamount || 0,
                                  "INR",
                                )}
                              </td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  SaleReturnData?.returnGrandTotalRounded || 0,
                                  "INR",
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "left",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                                colSpan="3"
                              >
                                Total Amount In Words
                              </td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                                colSpan="4"
                              >
                                Total Amount Before Tax
                              </td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  SaleReturnData?.totalbaseprice || 0,
                                  "INR",
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                                colSpan="3"
                                rowSpan="5"
                              >
                                {SaleReturnData?.amountinwordsTotalReturnAmount}
                              </td>
                            </tr>
                            {SaleReturnData?.billingStoreProfileData
                              ?.statecode &&
                            SaleReturnData?.CustomerInfo?.statecode &&
                            SaleReturnData?.billingStoreProfileData
                              ?.statecode !==
                              SaleReturnData?.CustomerInfo?.statecode ? (
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="4"
                                >
                                  IGST
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    SaleReturnData?.returnIgstamount || 0,
                                    "INR",
                                  )}
                                </td>
                              </tr>
                            ) : (
                              <>
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "right",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                    colSpan="4"
                                  >
                                    SGST
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      SaleReturnData?.returnSgstamount || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "right",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                    colSpan="4"
                                  >
                                    CGST
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      SaleReturnData?.returnCgstamount || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                              </>
                            )}
                            <tr>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "right",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                                colSpan="4"
                              >
                                TOTAL
                              </td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  SaleReturnData?.totalReturnAmount || 0,
                                  "INR",
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "right",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                }}
                                colSpan="4"
                              >
                                Grand Total (Rounded)
                              </td>
                              <td
                                className="force-style"
                                style={{
                                  textAlign: "center",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                  "--th-color":
                                    selectedTheme?.templateTheme
                                      ?.foregroundColor,
                                  "--th-bg":
                                    selectedTheme?.templateTheme?.primaryColor,
                                  "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                }}
                              >
                                ₹
                                {CurrencyConverter.toCurrency(
                                  SaleReturnData?.returnGrandTotalRounded || 0,
                                  "INR",
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {SaleReturnData?.totaldiscount > 0 && (
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  Your Total Discount : ₹
                                  {CurrencyConverter.toCurrency(
                                    SaleReturnData?.totaldiscount || 0,
                                    "INR",
                                  )}
                                  {/* <br />
                                    <div className="mt-1 fs-20">
                                      ***** Thank You! Visit Us Again *****
                                    </div> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        )}
                        {(payDetails?.CASH > 0 ||
                          payDetails?.CARD > 0 ||
                          payDetails?.ONLINE > 0 ||
                          payDetails?.UPI > 0 ||
                          payDetails?.PAYLATER > 0) && (
                          <table
                            className="items mt-2"
                            width="38%"
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  colSpan={2}
                                  className="force-style"
                                  style={{
                                    width: "100%",
                                    textAlign: "center",
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                  }}
                                >
                                  Refund Method
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {payDetails?.CASH > 0 && (
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    Cash
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      payDetails?.CASH || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                              )}
                              {payDetails?.CARD > 0 && (
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    Card
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      payDetails?.CARD || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                              )}
                              {payDetails?.ONLINE > 0 && (
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    OnlineAmount
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      fontWeight: "600",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      payDetails?.ONLINE || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                              )}
                              {payDetails?.UPI > 0 && (
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    UPI
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      fontWeight: "600",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      payDetails?.UPI || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                              )}
                              {payDetails?.PAYLATER > 0 && (
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    BalanceDue
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "start",
                                      fontSize: "12px",
                                      width: "10%",
                                      fontWeight: "600",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    ₹
                                    {CurrencyConverter.toCurrency(
                                      payDetails?.PAYLATER || 0,
                                      "INR",
                                    )}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}
                        {optData?.isRemark && SaleReturnData?.remarks && (
                          <table width="100%" className="mb-2 mt-2">
                            <tbody>
                              <tr>
                                <td width="100%">
                                  <div className="font-12 fw-600 align-left text-black mb-1">
                                    Remark
                                  </div>

                                  <div
                                    className="font-12 p-0"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                      minHeight: "30px",
                                    }}
                                  >
                                    {capitalizeFirstLetter(
                                      SaleReturnData?.remarks,
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        )}

                        <div className="mt-2 fs-20 d-flex justify-content-center fw-bold">
                          <span>***** Thank You! Visit Us Again *****</span>
                        </div>
                        {storeSettings?.negobillBranding && (
                          <>
                            <div className="mt-1 fs-20 d-flex justify-content-center fw-bold">
                              <span>Powered By</span>
                            </div>
                            <div className=" fs-20 d-flex justify-content-center fw-bold">
                              <span>www.NegoBill.com</span>
                            </div>
                          </>
                        )}
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  padding: "8px",
                                  marginTop: "15px",
                                }}
                                className="d-flex align-items-start justify-content-end"
                              >
                                <div>
                                  {storeSettings?.invoiceSettings
                                    ?.signature && (
                                    <div className="text-end p-0 fw-bold ">
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          storeSettings?.invoiceSettings
                                            ?.signature
                                        }
                                        width={150}
                                      />
                                    </div>
                                  )}
                                  <div className="text-end p-0">
                                    Issued By,Signature
                                  </div>
                                  <div className="text-end p-0 fw-bold ">
                                    {
                                      SaleReturnData?.billingStoreProfileData
                                        ?.title
                                    }
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

         
          </div>
        )}
        <InvoiceInfoSidebar
          globalData={SaleReturnData}
          isData={data}
          optData={optData}
          returnTrack={SaleReturnData?.returnTrack}
          handlelatestSale={handlelatestSale}
          handleSelectedReturnSale={handleSelectedReturnSale}
          closeAuto={closeAuto}
          setCloseAuto={setCloseAuto}
          latestVersion={latestVersion}
        />
      </InvoiceModalLayout>

      {showConfirm && (
        <Convertinvoice
          onClose={() => setShowConfirm(false)}
          onConfirm={() => handleGenerateInvoice(data)}
        />
      )}
      <PaySettleModal
        isOpen={isPaySettleModalOpen}
        data={data}
        setIsPaySettleModalOpen={setIsPaySettleModalOpen}
        setIsMainModalOpen={setIsMainModalOpen}
        isBtnLoading={isBtnLoading}
        setBtnLoading={setBtnLoading}
      />
    </>
  );
};

export default ReturnSaleInvoice;
